/** @format */

export const ChatSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.99967 2C4.33301 2 1.33301 4.38667 1.33301 7.33333C1.36634 8.76667 2.03967 10.1133 3.16634 11C3.16634 11.4 2.88634 12.4467 1.33301 14C2.91301 13.9267 4.42634 13.3333 5.64634 12.3333C6.40634 12.5533 7.20634 12.6667 7.99967 12.6667C11.6663 12.6667 14.6663 10.28 14.6663 7.33333C14.6663 4.38667 11.6663 2 7.99967 2ZM7.99967 11.3333C5.05301 11.3333 2.66634 9.54 2.66634 7.33333C2.66634 5.12667 5.05301 3.33333 7.99967 3.33333C10.9463 3.33333 13.333 5.12667 13.333 7.33333C13.333 9.54 10.9463 11.3333 7.99967 11.3333Z"
                fill={color}
            />
        </svg>
    );
};
